<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-btn 
                            v-if="goBackText"
                            block
                            color="error"
                            @click="goBack()"
                        >{{ goBackText }}</v-btn>
                    </v-flex>
                    <v-flex xs12 md6>
                        <h1 class="text-xs-center">{{ status }}</h1>
                    </v-flex>
                </v-layout>  
                <v-layout>
                    <v-flex xs12>
                        <v-progress-linear
                            :color="color"
                            :background-color="backgroundColor"
                            height="12"
                            :value="progress"
                            :indeterminate="confirming"
                        ></v-progress-linear>
                    </v-flex>
                </v-layout>                  
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    components: {

    },
    props: [
        'stage',
        'confirming',
        'confirmError'
    ],
    data() {
        return {

        };
    },
    computed: {
        color(){
            if(this.confirming){
                return "info";
            }

            return "success";
        },
        backgroundColor(){
            if(this.confirming){
                return null;
            }

            if(this.confirmError){
                return "error";
            }

            return null;
        },
        goBackText(){
            if(this.stage == 0){
                return null;
            }

            if(this.stage == 1 || this.stage == 2){
                return "Modify Order";
            }

            return null;
        },
        status(){
            if(this.stage == 0){
                return "Placing New Order";
            }

            if(this.stage == 1){
                return "Confirming New Order";
            }

            if(this.stage == 2){
                return "Send To Suppliers";
            }

            if(this.stage == 3){
                return "Order Sent";
            }
        },
        progress(){
            return 100 * (1 + this.stage) / 4;
        }
    },
    methods: {
        goBack(){
            this.$emit("onBack");
        }
    }
};
</script>

<style>

</style>
